export const LOGIN_REQUEST="LOGIN_REQUEST"
export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAIL="LOGIN_FAIL"
export const LOGOUT="LOGOUT"

export const REGISTER_REQUEST="REGISTER_REQUEST"
export const REGISTER_SUCCESS="REGISTER_SUCCESS"
export const REGISTER_FAIL="REGISTER_FAIL"

export const USER_UPDATE_REQUEST="USER_UPDATE_REQUEST"
export const USER_UPDATE_SUCCESS="USER_UPDATE_SUCCESS"
export const USER_UPDATE_FAIL="REGISTER_FAIL"